import pruneObject from 'utils/objectPrune';

import { TrackerHelperFragment } from '../helpers/';


export default class GeneralTracker extends TrackerHelperFragment {
  CAPTURE_NAME = 'event:tracking:general';
  STORAGE_KEY = 'eventTrackingSorageKey';
  EVENT_GROUP = 'general';
  DATALAYER = false;
  HANDLERS = {};
  VERSION = '1';

  constructor() {
    super();
    this.state = {};
  }

  init(service) {
    this.service = service;

    this.logger = service.logger.child({ childName: this.EVENT_GROUP });
    this.setHandlers();
  }

  track(payload, datalayer = false) {
    if (datalayer === true || this.DATALAYER === true) {
      this.dataLayerPush(payload);
    } else {
      const cleanPayload = pruneObject(payload);

      this.service.track(this.CAPTURE_NAME, {
        version: this.VERSION,
        group: this.EVENT_GROUP,
        ...cleanPayload,
      });
    }
  }

  dataLayerPush = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  passthrough = (payload) => {
    this.track(payload);
  };

  getService() {
    if (this.service === undefined) {
      throw new Error('Service is undefined, please use `init` first.');
    }

    return this.service;
  }
}
